import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Mail, FileText } from 'lucide-react';
import type { AuditException } from '@/types/asset-audit';
import { formatDistanceToNow } from 'date-fns';

interface AuditorNotesSectionProps {
  exception: AuditException;
}

export function AuditorNotesSection({ exception }: Readonly<AuditorNotesSectionProps>) {
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const handleContactAuditor = () => {
    // TODO: Implement contact auditor functionality
    console.log('Contact auditor:', exception.reportedByName);
  };

  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <FileText className="h-5 w-5 text-gray-500" />
        <Label className="text-base font-semibold">Auditor</Label>
      </div>

      <div className="space-y-4">
        {/* Reporter Info */}
        <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg">
          <Avatar className="h-10 w-10">
            <AvatarImage 
              src={`https://api.dicebear.com/7.x/initials/svg?seed=${exception.reportedByName}`} 
              alt={exception.reportedByName} 
            />
            <AvatarFallback>{getInitials(exception.reportedByName)}</AvatarFallback>
          </Avatar>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between mb-1">
              <span className="font-medium text-sm">{exception.reportedByName}</span>
              <span className="text-xs text-muted-foreground">
                {formatDistanceToNow(new Date(exception.reportedDate), { addSuffix: true })}
              </span>
            </div>
            <p className="text-sm text-muted-foreground">Auditor</p>
          </div>
        </div>

        {/* Contact Button */}
        <Button 
          variant="outline" 
          className="w-full"
          onClick={handleContactAuditor}
        >
          <Mail className="h-4 w-4 mr-2" />
          Contact Auditor
        </Button>
      </div>
    </div>
  );
}
